module.exports = __webpack_public_path__ + "8eefdc4a7f43a261847f4d6c819483a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/developpement/web_design.jpg
// module id = 161
// module chunks = 0